








































































import { Component, Vue } from "vue-property-decorator";
import { CONFIG } from "@/graphql/config";
import { IConfig } from "@/types/config.model";
import { LOGGED_USER_MEMBERSHIPS } from "@/graphql/actor";
import { LEAVE_GROUP } from "@/graphql/group";
import GroupMemberCard from "@/components/Group/GroupMemberCard.vue";
import Invitations from "@/components/Group/Invitations.vue";
import { Paginate } from "@/types/paginate";
import { IGroup, usernameWithDomain } from "@/types/actor";
import { Route } from "vue-router";
import { IMember } from "@/types/actor/member.model";
import { MemberRole } from "@/types/enums";
import { supportsWebPFormat } from "@/utils/support";
import RouteName from "../../router/name";

@Component({
  components: {
    GroupMemberCard,
    Invitations,
  },
  apollo: {
    config: {
      query: CONFIG,
    },
    membershipsPages: {
      query: LOGGED_USER_MEMBERSHIPS,
      fetchPolicy: "cache-and-network",
      variables() {
        return {
          page: this.page,
          limit: this.limit,
        };
      },
      update: (data) => data.loggedUser.memberships,
    },
  },
  metaInfo() {
    return {
      title: this.$t("My groups") as string,
      titleTemplate: "%s | Mobilizon",
    };
  },
})
export default class MyGroups extends Vue {
  membershipsPages!: Paginate<IMember>;

  RouteName = RouteName;

  config!: IConfig;

  page = 1;

  limit = 10;

  supportsWebPFormat = supportsWebPFormat;

  acceptInvitation(member: IMember): Promise<Route> {
    return this.$router.push({
      name: RouteName.GROUP,
      params: { preferredUsername: usernameWithDomain(member.parent) },
    });
  }

  rejectInvitation({ id: memberId }: { id: string }): void {
    const index = this.membershipsPages.elements.findIndex(
      (membership) =>
        membership.role === MemberRole.INVITED && membership.id === memberId
    );
    if (index > -1) {
      this.membershipsPages.elements.splice(index, 1);
      this.membershipsPages.total -= 1;
    }
  }

  async leaveGroup(group: IGroup): Promise<void> {
    try {
      const { page, limit } = this;
      await this.$apollo.mutate({
        mutation: LEAVE_GROUP,
        variables: {
          groupId: group.id,
        },
        refetchQueries: [
          {
            query: LOGGED_USER_MEMBERSHIPS,
            variables: {
              page,
              limit,
            },
          },
        ],
      });
    } catch (error: any) {
      if (error.graphQLErrors && error.graphQLErrors.length > 0) {
        this.$notifier.error(error.graphQLErrors[0].message);
      }
    }
  }

  get invitations(): IMember[] {
    if (!this.membershipsPages) return [];
    return this.membershipsPages.elements.filter(
      (member: IMember) => member.role === MemberRole.INVITED
    );
  }

  get memberships(): IMember[] {
    if (!this.membershipsPages) return [];
    return this.membershipsPages.elements.filter(
      (member: IMember) =>
        ![MemberRole.INVITED, MemberRole.REJECTED].includes(member.role)
    );
  }

  get hideCreateGroupButton(): boolean {
    return !!this.config?.restrictions?.onlyAdminCanCreateGroups;
  }
}
